// extracted by mini-css-extract-plugin
export var deliveryRow = "_s8-a";
export var fixedHeight = "_s8-4";
export var freightLogo = "_s8-9";
export var fullWidth = "_s8-3";
export var priceColumn = "_s8-5";
export var radioSelected = "_s8-7";
export var radioUnselected = "_s8-6";
export var selectedOption = "_s8-2";
export var selectedOptionContainer = "_s8-1";
export var selection = "_s8-0";
export var tallSkeletonText = "_s8-8";